import type { CaseVerdict } from "@exploitlens/ui-contracts";

/** Case-level rollup, distinguished by symbol + label + border style, not color alone. */
const PRESENTATION: Record<
  CaseVerdict,
  { symbol: string; label: string; border: string; text: string; bg: string }
> = {
  verified: {
    symbol: "✓",
    label: "Verified",
    border: "border-preserved",
    text: "text-preserved",
    bg: "bg-preserved-surface",
  },
  regression: {
    symbol: "✕",
    label: "Regression",
    border: "border-loss",
    text: "text-loss",
    bg: "bg-loss-surface",
  },
  invalid: {
    symbol: "!",
    label: "Invalid run",
    border: "border-loss border-dashed",
    text: "text-loss",
    bg: "bg-loss-surface",
  },
  inconclusive: {
    symbol: "?",
    label: "Inconclusive",
    border: "border-rule-strong border-dashed",
    text: "text-ink-muted",
    bg: "bg-surface",
  },
};

export function VerdictBadge({ verdict }: { verdict: CaseVerdict }) {
  const p = PRESENTATION[verdict];
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border ${p.border} ${p.bg} px-4 py-1.5 text-sm font-medium ${p.text}`}
    >
      <span aria-hidden="true">{p.symbol}</span>
      {p.label}
    </span>
  );
}
